<template>
  <div class="text-center no-item" v-if="list && list.length == 0">
    <br>
    <div>{{ msg ? msg : 'Nenhum item encontrado'}}</div>
  </div>
</template>

<script>
export default {
  name: 'no-item',
  props: ['list', 'msg']
};
</script>
